import { useDispatch } from "react-redux";
import Mode from "../../components/styles/Mode";
import cookies from "../../utilities/Cookies";
import { useEffect, useState } from "react";
import { saveTrustedFormCert, triggerRetell1 } from "../../utilities/utils";
import Flexbox from "../../components/Flexbox";
import Spacebox from "../../components/Spacebox";
import { Typography } from "@mui/material";
import { updatedarkmode } from "../../features/mode";
import algorithms from "../../utilities/Algorithms";
import '../../css/no-cred.css'
import { isMobile } from "react-device-detect";

const FailedCredPull = () => {

    const dispatch = useDispatch()

    const [firstname, setFirstname] = useState(null)
    const [, setLastname] = useState(null)
    const [, setEmail] = useState(null)
    const [, setPhone] = useState(null)
    const [contactId, setContactId] = useState(null)
    const [result, setResult] = useState()
    const [loading,] = useState(false)


    const scrollToTop = () => window.scrollTo({ behavior: 'smooth', top: 0 })


    useEffect(() => {
        scrollToTop()
        cookies.setCookies('mode', 'light', 10)
        dispatch(updatedarkmode({ dark: false }))

        const urlParams = new URLSearchParams(window.location.search)
        const contact_id = urlParams.get('contact_id')
        const first_name = urlParams.get('first_name')
        const last_name = urlParams.get('last_name')
        const email_ = urlParams.get('email')
        const phone_ = urlParams.get('phone')
        // const result_ = urlParams.get('result')

        if (contact_id && first_name) {
            setContactId(contact_id)
            setFirstname(first_name)
            setLastname(last_name)
            setEmail(email_)
            setPhone(phone_)
            const amount = urlParams.get('amount')
            if (amount) {
                const res = algorithms.computeDebtPlan(parseFloat(amount))
                setResult(res)
            }
            triggerRetell1(contact_id)
            const trusted_cert = urlParams.get('trusted_form_cert_url')
            saveTrustedFormCert(trusted_cert, contact_id)
        }

        // eslint-disable-next-line
    }, [])
    return (
        <Mode>
            <div className="failed-cred-page" style={{ padding: isMobile ? '0px' : '0px 20px' }}>
                <div className="margin-auto mid" style={{ background: 'url("/assets/results-bg.png")', backgroundPosition: 'center', backgroundSize: 'cover' }}>
                    <div style={{ padding: 20 }}>
                        <Flexbox alignItems="center" justifyContent="center">
                            <img src="/logo-color.png" alt="final_debt_relief" style={{ width: '70px'}} />
                        </Flexbox>
                        <Spacebox padding="10px" />
                        <Typography style={{ fontSize: isMobile ? '25px' : '30px', textAlign: 'center' }} className="text-primary bold">
                            Almost There! <br />Let's <span className="bold trade-warning">Get You Connected</span>
                        </Typography>
                        <p style={{ textAlign: 'center' }}>
                            <span>A specialist will call you at the number provided <br /> in <b>approximately 3 minutes</b> </span>
                        </p>
                        <Spacebox padding="20px" />
                                <div className="agent-banner" style={{ background: '#143467', border: '3px solid #ffffff83', borderRadius: '10px', margin: 'auto', padding: '20px 30px', width: 'fit-content', transform: isMobile ? 'scale(1.0)' : 'scale(1.5)' }}>
                                    <div style={{ textAlign: 'center' }}>
                                        <span className="text-white">Our agent is calling you now from this number</span>
                                    </div>
                                    <Typography style={{ fontSize: isMobile ? '25px' : '30px', textAlign: 'center' }} className="trade-warning">
                                        <b className="bold">+1 (855) 780-4538</b>
                                    </Typography>
                                </div>
                        <Spacebox padding="40px" />
                        <div style={{ overflow: 'hidden', borderRadius: 20, maxWidth: '600px', margin: 'auto' }}>
                            <div style={{ background: '#f0f0f0', padding: '10px 20px', textAlign: 'center' }}>
                                <small><b>To ensure we provide you with the most accurate debt resolution options, we just need to quickly verify a few of the details you submitted.</b></small>
                            </div>
                            <div style={{ padding: '20px 40px', background: 'white' }}>
                                <Typography style={{ textAlign: 'center', fontSize: 20 }} className="text-primary">
                                    <b>What happens next:</b>
                                </Typography>
                                <Spacebox padding="20px" />
                                <Flexbox alignItems="center">
                                    {!isMobile && <div style={{ width: '100px', minWidth: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                        <img src="/assets/phone-icon.png" alt="" style={{ width: '60px' }} />
                                        
                                    </div>}
                                    <div>
                                        <small><b className="text-primary">Keep Your Phone Handy</b></small>
                                        <div></div>
                                        <small>
                                            <b>
                                                An agent is prioritizing your file right now and will call you momentarily
                                            </b>
                                        </small>
                                    </div>
                                </Flexbox>
                                <Spacebox padding="20px" />
                                <Flexbox alignItems="center">
                                    {!isMobile && <div style={{ width: '100px', minWidth: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                        <img src="/assets/verification-icon.png" alt="" style={{ width: '60px' }} />
                                    </div>}
                                    <div>
                                        <small><b className="text-primary">Quick Confirmation</b></small>
                                        <div></div>
                                        <small>
                                            <b>
                                                We will go over your details together to make sure everything is 100% correct.
                                            </b>
                                        </small>
                                    </div>
                                </Flexbox>
                                <Spacebox padding="20px" />
                                <Flexbox alignItems="center">
                                    {!isMobile && <div style={{ width: '100px', minWidth: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                        <img src="/assets/call-icon.png" alt="" style={{ width: '60px' }} />
                                    </div>}
                                    <div>
                                        <small><b className="text-primary">Expert Transfer</b></small>
                                        <div></div>
                                        <small>
                                            <b>
                                                As soon as we've confirmed your info, we will connect you directly to a debtresolution agent to discuss your personalized savings plan.
                                            </b>
                                        </small>
                                    </div>
                                </Flexbox>
                                <Spacebox padding="20px" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Mode>
    );
}

export default FailedCredPull;